import { useNavigate } from "react-router-dom";

import Logo from "../assets/images/IndusindLogo.png";
import CarePlixLogo from "../assets/images/CarePlixLogo.png";
import HealthLensScreen3 from "../assets/images/HealthLensScreen3.jpg";

const GetStarted = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-stretch justify-start bg-white">
      <div className="flex-shrink-0 p-6 pt-8 flex items-center">
        <img className="h-12" src={Logo} alt="logo" />
        <div className="w-px h-8 bg-gray-300 mx-3" />
        <div className="flex flex-col items-start">
          <span className="text-gray-500 text-xs leading-tight font-medium">Powered by</span>
          <img className="h-5 mt-0.5 object-contain" src={CarePlixLogo} alt="CarePlix" />
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center">
        <img className="w-full object-cover" src={HealthLensScreen3} alt="HealthLens health scan" />
      </div>
      <div className="flex-shrink-0 px-8 pb-4 pt-4">
        <h1 className="text-2xl leading-tight font-bold" style={{ color: "#a15a51" }}>
          Monitor Customer Health Anytime, Anywhere
        </h1>
        <button
          className="w-full mt-8 px-4 py-3 rounded-full bg-gradient-to-r from-[#1845a3] to-[#ED1C24] text-white text-lg font-semibold shadow-lg hover:shadow-xl transition-shadow"
          type="button"
          onClick={() => navigate("/validate-referral")}
        >
          Get Started
        </button>
      </div>
      <div className="flex-shrink-0 px-8 pb-6">
        <p className="text-xxs text-gray-400 text-justify leading-relaxed">
          <span className="font-semibold text-gray-500">Disclaimer:</span> For Investigational Use Only. Careplix is not a substitute for the clinical judgment of a healthcare professional. Careplix is intended to improve your awareness of general wellness. Careplix does not diagnose, treat, mitigate or prevent any disease, symptom, disorder or abnormal physical state. Consult with a health care professional or emergency services if you believe you may have a medical issue.
        </p>
        <p className="mt-2 text-gray-400 text-left font-semibold leading-relaxed" style={{ fontSize: "0.55rem" }}>
          Indusindinsurance.com | 022 4890 3009 (Paid) | 74004 22200 (WhatsApp)
        </p>
        <p className="mt-1 text-gray-400 text-justify leading-relaxed" style={{ fontSize: "0.55rem" }}>
          T&C Apply. IRDAI Registration No. 103. IndusInd General Insurance Company Limited (Formerly known as Reliance General Insurance Company Limited). An ISO 9001:2015 Certified Company. Registered & Corporate Office: 6th Floor, Oberoi Commerz, International Business Park, Oberoi Garden City, Off. Western Express Highway, Goregaon (E), Mumbai-400063. Corporate Identity Number: U66603MH2000PLC128300.
        </p>
      </div>
    </div>
  );
};

export default GetStarted;
